const cards = [
  {
    title: '国产高清视频专区',
    desc: '汇聚最新最全91国产高清视频资源，每日筛选优质内容，画质清晰内容精彩，满足多样化观影需求。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20visual%20representing%20curated%20video%20content%20collection%2C%20warm%20coral%20and%20gold%20gradients%2C%20organized%20geometric%20grid%20pattern%20with%20soft%20highlights%2C%20dark%20sophisticated%20background%2C%20premium%20editorial%20aesthetic%2C%20refined%20modern%20digital%20art%20style&width=600&height=400&seq=card-91md-01&orientation=landscape',
    tag: '热门专区',
  },
  {
    title: '超清画质体验',
    desc: '全站支持1080P超清视频在线观看，先进的视频编码技术与智能传输确保每一帧都清晰细腻呈现。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20representation%20of%20high%20definition%20visual%20quality%2C%20crystal%20clear%20geometric%20shapes%20in%20warm%20amber%20tones%2C%20sharp%20detailed%20patterns%20with%20soft%20glowing%20edges%2C%20dark%20premium%20backdrop%2C%20modern%20minimalist%20tech%20aesthetic&width=600&height=400&seq=card-91md-02&orientation=landscape',
    tag: '超清画质',
  },
  {
    title: '流畅不卡顿播放',
    desc: '智能CDN加速网络搭配自适应码率技术，无论WiFi还是移动网络，都能获得丝滑流畅的播放体验。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20representing%20smooth%20seamless%20streaming%20experience%2C%20flowing%20wave%20patterns%20in%20warm%20coral%20and%20copper%20colors%2C%20continuous%20curved%20lines%20suggesting%20uninterrupted%20flow%2C%20dark%20elegant%20background%2C%20modern%20dynamic%20composition&width=600&height=400&seq=card-91md-03&orientation=landscape',
    tag: '流畅体验',
  },
  {
    title: '每日更新不间断',
    desc: '专业运营团队全天候更新内容库，91高清视频在线资源每日准时上新，热门内容永不错过。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20art%20depicting%20continuous%20renewal%20and%20freshness%2C%20warm%20golden%20sunrise%20gradients%20with%20rotating%20geometric%20elements%2C%20dynamic%20circular%20patterns%20suggesting%20daily%20cycles%2C%20dark%20sophisticated%20foundation%2C%20elegant%20modern%20visual%20identity&width=600&height=400&seq=card-91md-04&orientation=landscape',
    tag: '每日更新',
  },
  {
    title: '海量资源库',
    desc: '涵盖91国产视频、高清影视在线等多种分类，超过20000部精选资源，满足各类观影偏好与需求。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20representing%20vast%20digital%20content%20library%2C%20layered%20overlapping%20shapes%20in%20warm%20terracotta%20and%20bronze%20tones%2C%20expansive%20depth%20with%20soft%20gradients%2C%20dark%20elegant%20atmosphere%2C%20premium%20archive%20aesthetic%2C%20sophisticated%20composition&width=600&height=400&seq=card-91md-05&orientation=landscape',
    tag: '海量资源',
  },
  {
    title: '安全稳定可靠',
    desc: '采用企业级服务器架构与多重防护体系，保障平台稳定运行与用户观看安全，打造放心的观影环境。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20security%20and%20stability%2C%20solid%20geometric%20shield%20forms%20in%20warm%20coral%20and%20amber%20accents%2C%20reliable%20structured%20patterns%20with%20soft%20glow%2C%20dark%20trustworthy%20background%2C%20modern%20corporate%20digital%20art%20style&width=600&height=400&seq=card-91md-06&orientation=landscape',
    tag: '安全保障',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选六大特色专题，全方位了解91麻豆免费视频网站的核心优势
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}